import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Printer, ImageOff, AlertTriangle } from "lucide-react";
import { codeIssue, imageUrl } from "@/lib/modelSheets";

const printUrl = (s, tipo) => `/modellistica/${s.id}/stampa?tipo=${tipo}`;

export const SheetCard = ({ sheet: s, onOpen, showSeason }) => {
  const img = imageUrl(s);
  const open = (tipo) => (e) => { e.stopPropagation(); window.open(printUrl(s, tipo), "_blank"); };
  return (
    <Card className="group cursor-pointer overflow-hidden transition-colors hover:border-primary/50" onClick={onOpen} data-testid={`sheet-card-${s.id}`}>
      <div className="flex h-40 items-center justify-center overflow-hidden bg-secondary/40">
        {img ? <img src={img} alt={s.name} className="h-full w-full object-contain transition-transform group-hover:scale-[1.03]" />
          : <ImageOff className="h-8 w-8 text-muted-foreground/50" />}
      </div>
      <div className="space-y-2 p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <span className={`inline-block rounded-md px-2.5 py-0.5 font-mono-erp text-sm font-bold tracking-wider ${s.code ? "bg-primary text-primary-foreground" : "border border-dashed border-amber-400/60 text-amber-400"}`} data-testid={`sheet-card-code-${s.id}`}>{s.code ? s.code.toUpperCase() : "SENZA CODICE"}</span>
            <p className="mt-1.5 truncate font-display font-semibold" data-testid={`sheet-card-name-${s.id}`}>{s.name}</p>
          </div>
          <div className="flex shrink-0 flex-col items-end gap-1">
            {showSeason && <Badge variant="outline" className="text-[10px]">{s.season}</Badge>}
          </div>
        </div>
        {codeIssue(s.code, s.season) && (
          <p className="flex gap-1 text-[11px] text-amber-400" data-testid={`sheet-card-code-warning-${s.id}`}><AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />{!s.code ? "Codice modello mancante" : codeIssue(s.code, s.season).startsWith("Il codice indica") ? "Stagione del codice diversa da quella della scheda" : "Codice non nel formato Shopify"}</p>
        )}
        <p className="text-xs text-muted-foreground">{(s.sizes || []).join(" · ")}</p>
        <div className="flex gap-2 pt-1">
          <Button size="sm" variant="outline" className="h-7 flex-1 text-xs" onClick={open("tecnica")} data-testid={`sheet-print-tecnica-${s.id}`}><Printer className="mr-1 h-3.5 w-3.5" />Stampa scheda tecnica</Button>
        </div>
      </div>
    </Card>
  );
};
